import { Download, FileText, Loader2, Paperclip } from 'lucide-react';
import { formatSedDateTime, formatSedFileSize, type SedFileInfo } from '@/lib/sed';

export function SedFilesBlock({
  files,
  loading,
  error,
  downloadingId,
  onDownload,
}: {
  files: SedFileInfo[];
  loading: boolean;
  error: string;
  downloadingId: string;
  onDownload: (file: SedFileInfo) => void;
}) {
  return (
    <section className="rounded-2xl border bg-card p-3">
      <div className="flex items-center gap-2">
        <Paperclip className="h-4 w-4 text-primary" />
        <h3 className="text-sm font-semibold">Файлы</h3>
        {!loading && !error && files.length > 0 && (
          <span className="ml-auto text-[10px] text-muted-foreground">{files.length}</span>
        )}
      </div>

      {loading && <p className="mt-2 text-xs text-muted-foreground">Загрузка файлов…</p>}

      {!loading && error && (
        <p className="mt-2 rounded-lg border border-red-500/30 bg-red-500/10 px-2 py-1.5 text-[11px] text-red-700">
          {error}
        </p>
      )}

      {!loading && !error && files.length === 0 && (
        <p className="mt-2 text-[11px] text-muted-foreground">
          Файлов нет. Прикрепите их в форме документа — вкладка «Файлы».
        </p>
      )}

      {!loading && !error && files.length > 0 && (
        <ul className="mt-2 space-y-1.5">
          {files.map((file) => (
            <li key={file.id} className="flex items-center gap-2 rounded-xl border bg-background/60 px-2 py-1.5">
              <FileText className="h-4 w-4 shrink-0 text-muted-foreground" />
              <div className="min-w-0 flex-1">
                <div className="truncate text-xs font-medium">{file.fileName || 'Файл'}</div>
                <div className="text-[10px] text-muted-foreground">
                  {[formatSedFileSize(file.fileSize), file.uploadedBy, file.uploadedAt ? formatSedDateTime(file.uploadedAt) : '']
                    .filter(Boolean)
                    .join(' · ')}
                </div>
              </div>
              <button
                type="button"
                onClick={() => onDownload(file)}
                disabled={downloadingId === file.id}
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground disabled:opacity-50"
                aria-label={`Скачать ${file.fileName}`}
              >
                {downloadingId === file.id ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
